import { computed, Ref } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { maxLength, helpers } from '@vuelidate/validators'

interface EventWefoData {
  tile_title: string
  title1: string
  title2: string
  description: string
  walking_time: number | null
}

const msg = (message: string, validator: any) => helpers.withMessage(message, validator)

const optionalInteger = helpers.withMessage(
  'Fußweg muss eine ganze Zahl sein.',
  (val: number | null) => val === null || val === undefined || Number.isInteger(Number(val))
)

const optionalBetween = helpers.withMessage(
  'Fußweg muss zwischen 1 und 999 Minuten liegen.',
  (val: number | null) => val === null || val === undefined || (Number(val) >= 1 && Number(val) <= 999)
)

export function useEventWefoValidation(data: Ref<EventWefoData>, enabled: Ref<boolean>) {
  const rules = computed(() => {
    if (!enabled.value) return {}

    return {
      tile_title: {
        maxLength: msg('Kachel-Titel darf max. 255 Zeichen lang sein.', maxLength(255)),
      },
      title1: {
        maxLength: msg('Titel 1 darf max. 255 Zeichen lang sein.', maxLength(255)),
      },
      title2: {
        maxLength: msg('Titel 2 darf max. 255 Zeichen lang sein.', maxLength(255)),
      },
      description: {
        maxLength: msg('Beschreibung darf max. 5000 Zeichen lang sein.', maxLength(5000)),
      },
      walking_time: {
        optionalInteger,
        optionalBetween,
      },
    }
  })

  const v$ = useVuelidate(rules, data, { $lazy: true })

  return { v$ }
}
